if (!customElements.get('ly-table')) {
    customElements.define('ly-table', class extends HTMLElement {

        color1 = this.dataset.color1 || '#61997a'
        color2 = this.dataset.color2 || '#1e4a32'

        #observer = null

        tableHeight = 0
        rowHeights = []

        connectedCallback() {
            this.table = this.querySelector('table')
            this.rows = [...this.querySelectorAll('.row')]
            this.stickyCols = [...this.querySelectorAll('.col_1')]

            this.#observer = new ResizeObserver(this.resizeHandler)
            this.#observer.observe(this)
        }

        disconnectedCallback() {
            this.#observer?.disconnect()
            this.#observer = null
        }

        resizeHandler = () => {
            if (!this.table) return
            const height = this.table.offsetHeight
            if (this.tableHeight !== height) {
                this.tableHeight = height
            }
            this.rows.forEach((row, index) => {
                const h = row.offsetHeight
                if (this.rowHeights[index] !== h) {
                    this.rowHeights[index] = h
                }
            })

            this.setStickyColsBackground()
        }

        /** 设置固定列的背景 */
        setStickyColsBackground = () => {
            if (!this.stickyCols.length) return

            this.stickyCols.forEach((col, index) => {
                const ratio = this.rowHeights.slice(0, index + 1).reduce((a, b) => a + b, 0) / this.tableHeight
                col.style.background = this.lerpColor(this.color1, this.color2, ratio)
            })
        }

        /** 线性插值两种颜色 */
        lerpColor = (color1, color2, t) => {
            const c1 = color1.match(/\w\w/g).map(x => parseInt(x, 16))
            const c2 = color2.match(/\w\w/g).map(x => parseInt(x, 16))
            const r = Math.round(c1[0] + (c2[0] - c1[0]) * t)
            const g = Math.round(c1[1] + (c2[1] - c1[1]) * t)
            const b = Math.round(c1[2] + (c2[2] - c1[2]) * t)
            return `rgb(${r}, ${g}, ${b})`
        }

    })
}